module.exports = __webpack_public_path__ + "img/901766008.d6f18ddd.png";